import * as React from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { analyticsState } from 'state/analytics';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';
import { downloadImage } from 'utils/ui/downloadImage';
import { downloadImagesAsZip } from 'utils/ui/downloadImagesAsZip';
import { handleDownloadError } from 'utils/ui/handleDownloadError';
import { DownloadMenuButton } from './DownloadMenuButton';

export default function Download2dImageMenuItem() {
  const session = userSession().useState();
  tenantConfig().useState();
  const [isDownloadingAll, setIsDownloadingAll] = React.useState(false);

  const carImages = session.carImages;
  const demoImages = carImages?.items?.filter((item) => !item.mode || item.mode === 'demo');
  const carName = session.carDisplayName || undefined;
  const currentImageIndex = session.currentImageIndex;

  if (!userSession().canDownload2dImage || !demoImages?.length) {
    return false;
  }

  const handleDownloadCurrent = async () => {
    const image = demoImages[currentImageIndex];
    if (!image) return;

    try {
      await downloadImage(image.source, image.title, carName);
      analyticsState().setValues({ dealerToolUsed: 'downloadImage' });
    } catch {
      handleDownloadError('ERROR_2D_DOWNLOAD_CURRENT');
    }
  };

  const handleDownloadAll = async () => {
    if (isDownloadingAll) return;
    setIsDownloadingAll(true);
    try {
      await downloadImagesAsZip(demoImages, carName);
      analyticsState().setValues({ dealerToolUsed: 'downloadAllImages' });
    } catch {
      handleDownloadError('ERROR_2D_DOWNLOAD_ZIP_FAILED', t`Failed to prepare zip download`);
    } finally {
      setIsDownloadingAll(false);
    }
  };

  return (
    <>
      <DownloadMenuButton
        onClick={handleDownloadCurrent}
        label={<Trans>Download current image</Trans>}
        testId="download-current-image"
      />
      {demoImages.length > 1 && (
        <>
          <DownloadMenuButton
            onClick={handleDownloadAll}
            label={<Trans>Download all images</Trans>}
            testId="download-all-images"
            loading={isDownloadingAll}
            variant="all"
          />
          <span aria-live="polite" className="sr-only" data-testid="download-all-images-status">
            {isDownloadingAll ? <Trans>Preparing download…</Trans> : ''}
          </span>
        </>
      )}
    </>
  );
}
